import { isIE } from '../utilities/browserUtils';
export var ribbonExperiments = {
    renderInitiallyEnabledRibbonIsEnabled: 'RenderInitiallyEnabledRibbonIsEnabled',
    updatedTellMePlaceholderIsEnabled: 'UpdatedTellMePlaceholderIsEnabled',
    multilineRibbonIsEnabled: 'ReactMultilineRibbonIsEnabled',
    shadowRenderingIsEnabled: 'ShadowRenderingIsEnabled',
    taskPaneResizingIsEnabled: 'TaskPaneResizingIsEnabled',
    areControlsConnectedToStore: 'AreControlsConnectedToStore',
    areMenusConnectedToStore: 'AreMenusConnectedToStore',
    activateComboAndSpinControlOnEnter: 'ActivateComboAndSpinMenuItemOnEnterIsEnabled',
    batchScaleDataInRibbon: 'BatchScaleDataInRibbon',
    sharedShyRibbonIsEnabled: 'SharedShyRibbonIsEnabled',
    shyRibbonIsEnabled: 'ShyRibbonIsEnabled',
    shyRibbonIsEnabledFG: 'Microsoft.Office.SharedOnline.ShyRibbonIsEnabled',
    ribbonCachedScalingIsEnabled: 'ReactRibbonCachedScalingIsEnabled',
    taskPaneBackgroundRefreshIsEnabled: 'TaskPaneBackgroundRefreshIsEnabled',
    quickRibbonScalingIsEnabled: 'QuickRibbonScalingIsEnabled',
    delayRibbonAnimationComponents: 'DelayAnimationComponentsIsEnabled',
    ribbonRenderBootThrottlingIsEnabled: 'RibbonRenderBootThrottlingIsEnabled',
    delayTabHeaderCalculationsIsEnabled: 'DelayTabHeaderCalculationsIsEnabled',
    fastDisabledRibbonControlGroupsIsEnabled: 'FastDisabledRibbonControlGroupsIsEnabled',
    ribbonUseV8Button: 'Microsoft.Office.SharedOnline.FluentV8ButtonIsEnabled',
    ribbonUseV8MenuButton: 'Microsoft.Office.SharedOnline.FluentV8MenuButtonIsEnabled',
    reactSharedHeaderIsEnabled: 'ReactSharedHeaderIsEnabled',
    hideHeaderEmbedded: 'HideHeaderEmbedded',
    delayRenderTooltipsIsEnabled: 'DelayRenderTooltipsIsEnabled',
    disableRibbonAnimationComponents: 'DisableAnimationComponentsIsEnabled',
    delayInstallAddInIsEnabled: 'DelayInstallAddInIsEnabled',
    modernUxExperimentOneIsEnabled: 'ModernUxExperimentOneIsEnabled',
    buildTimeRibbonScalingIsEnabled: 'BuildTimeRibbonScalingIsEnabled',
    tooltipsTargetOverflowSetItemEnabled: 'TooltipsTargetOverflowSetItemEnabled',
    disableColorPickerFancyTooltips: 'DisableColorPickerFancyTooltips',
    preventExcessColorPickerHandlersIsEnabled: 'PreventExcessColorPickerHandlersIsEnabled',
    batchTopBarScaleDataInRibbon: 'BatchTopBarScaleDataInRibbon',
    suppressCalloutWithOccludedTargetIsEnabled: 'SuppressCalloutWithOccludedTargetIsEnabled',
    buildTimeRibbonScalingMLRIsEnabled: 'Microsoft.Office.SharedOnline.BuildTimeRibbonScalingMLRIsEnabled',
    areControlsConnectedToStoreFG: 'Microsoft.Office.SharedOnline.AreControlsConnectedToStore',
    decentralizedScalingLogicIsEnabled: 'Microsoft.Office.SharedOnline.DecentralizedScalingLogicIsEnabled',
    perfMarkersIsEnabled: 'Microsoft.Office.SharedOnline.PerfMarkersIsEnabled',
    perfMarkerThrottlingOverrideIsEnabled: 'Microsoft.Office.SharedOnline.PerfMarkerThrottlingOverrideIsEnabled',
    fastDisabledRibbonControlGroupsIsEnabledFG: 'Microsoft.Office.SharedOnline.FastDisabledRibbonControlGroupsIsEnabled',
    shadowRenderingIsEnabledFG: 'Microsoft.Office.SharedOnline.ShadowRenderingIsEnabled',
    areMenusConnectedToStoreFG: 'Microsoft.Office.SharedOnline.AreMenusConnectedToStore',
};
export var checkExperiment = function (context, feature) {
    return context.isExperimentalFeatureEnabled && context.isExperimentalFeatureEnabled(feature);
};
export var isShyRibbonEnabled = function (context) {
    return isShyRibbonFeatureEnabled(context.isExperimentalFeatureEnabled);
};
export var isShyRibbonFeatureEnabled = function (isFeatureEnabled) {
    return (isFeatureEnabled !== undefined &&
        (isFeatureEnabled(ribbonExperiments.shyRibbonIsEnabled) ||
            (isFeatureEnabled(ribbonExperiments.shyRibbonIsEnabledFG) &&
                isFeatureEnabled(ribbonExperiments.sharedShyRibbonIsEnabled))) &&
        isFeatureEnabled(ribbonExperiments.reactSharedHeaderIsEnabled) &&
        !isFeatureEnabled(ribbonExperiments.hideHeaderEmbedded) &&
        !isIE());
};
//# sourceMappingURL=ribbonExperiments.js.map